import { render, staticRenderFns } from "./trashbin.vue?vue&type=template&id=5f7c3b37&"
import script from "./trashbin.vue?vue&type=script&lang=js&"
export * from "./trashbin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports